import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function AuthCallback() {
  const { processGoogleSession } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      nav('/auth', { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await processGoogleSession(sessionId);
        nav(user.onboarding_completed ? '/dashboard' : '/onboarding', { replace: true, state: { user } });
      } catch {
        nav('/auth', { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center" data-testid="auth-callback">
      <div className="animate-pulse font-display text-2xl text-sage">Authenticating...</div>
    </div>
  );
}
